import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  seeMore: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(2),
  },
  button: {
    margin: theme.spacing(3, 1, 3, 1), // top, rigth, bottom, left
  },
}));
